import _slicedToArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { makeUseContext } from "../utils.js";
var EventsContext = React.createContext(null);
export var useEvents = makeUseContext("useEvents", "EventsContext", EventsContext);
export var EventsProvider = function EventsProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      subscriptions = _React$useState2[0];

  React.useEffect(function () {
    return function () {
      Object.keys(subscriptions).forEach(function (key) {
        return delete subscriptions[key];
      });
    };
  }, [subscriptions]);
  var context = React.useMemo(function () {
    var unsubscribe = function unsubscribe(topic, callback) {
      if (subscriptions[topic]) {
        subscriptions[topic] = subscriptions[topic].filter(function (cb) {
          return cb !== callback;
        });
      }
    };

    var subscribe = function subscribe(topic, callback) {
      if (!subscriptions[topic]) {
        subscriptions[topic] = [];
      }

      subscriptions[topic].push(callback);
      return function () {
        return unsubscribe(topic, callback);
      };
    };

    var publish = function publish(topic, event) {
      var _a;

      (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.forEach(function (callback) {
        return callback(event);
      });
    };

    return {
      publish: publish,
      subscribe: subscribe,
      unsubscribe: unsubscribe
    };
  }, [subscriptions]);
  return React.createElement(EventsContext.Provider, {
    value: context
  }, children);
};